module.exports = __webpack_public_path__ + "static/img/hn.9b9bee13.svg";